import React from "react";
import { useTranslation } from "react-i18next";
import { SimpleUser } from "src/api/generated/frontend_internal_v1";
import { ApiInternal } from "src/api/api_internal";
import { ConfirmDialog } from "src/components/base/confirm-dialog";
import { notify } from "src/components/base/toast";

/**
 * The properties for {@link ExpireUserDevices}
 */
export type ExpireUserDevicesProps = {
    /** Whether the dialog is open */
    isOpen: boolean;

    /** What to do on closing of the popup */
    onClose: () => void;

    /** Callback when the devices are expired */
    onExpire: () => void;

    /** The user which devices should be expired */
    user: SimpleUser | undefined;
};

/**
 * Popup to expire all devices of a selected user
 */
export default function ExpireUserDevices(props: ExpireUserDevicesProps) {
    const [t] = useTranslation("dialog-expire-user-devices");

    if (!props.user) return null;

    return (
        <ConfirmDialog
            open={props.isOpen}
            onClose={props.onClose}
            onConfirm={async () => {
                if (!props.user) return;
                await ApiInternal.users.expireDevices(props.user.uuid);
                notify.success(t("toast.expired-user-devices"));
                props.onExpire();
            }}
            title={t("heading.expire-user-devices", { user: props.user.display_name })}
            description={t("description.expire-user-devices")}
            confirmLabel={t("button.expire-devices")}
        />
    );
}
